/**
 * http配置
 */
import axios from 'axios'

// axios 配置
axios.defaults.timeout = 5000

// axios.defaults.baseURL = api.baseRequestUrl
// http request 拦截器
axios.interceptors.request.use(
  config => {
    config.headers = {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
    return config
  },
  err => {
    return Promise.reject(err)
  }
)

// // 添加一个响应拦截器
// axios.interceptors.response.use(
//   function(res) {
//     if (!res.data.success) {
//       if (res.data.code === '410') {
//       }
//       return res
//     }
//     return res
//   },
//   function(err) {
//     console.info('error-')
//     return Promise.reject(err)
//   }
// )

export default axios



// WEBPACK FOOTER //
// ./src/plugin/axios.js